import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

const INITIAL_STATE = Immutable({
  orderGroups: [],
  orderCount: 0,
  location: {},
});

export const loadOrders = createAction('LOAD_SIGNAGE_ORDERS');
export const loadOrdersSucceeded = createAction('LOAD_SIGNAGE_ORDERS_SUCCEEDED');
export const loadOrdersFailed = createAction('LOAD_SIGNAGE_ORDERS_FAILED');

export const loadLocation = createAction('LOAD_SIGNAGE_LOCATION');
export const loadLocationSucceeded = createAction('LOAD_SIGNAGE_LOCATION_SUCCEEDED');
export const loadLocationFailed = createAction('LOAD_SIGNAGE_LOCATION_FAILED');

const uniqBy = (arr, key) => {
  const keys = new Set();
  return arr.filter(item => {
    const keyValue = item[key];
    return keys.has(keyValue) ? false : keys.add(keyValue);
  });
};


function groupBy(list, props) {
  return list.reduce((a, b) => {
    const result = a;
    (result[b[props]] = result[b[props]] || []).push(b);
    return result;
  }, {});
}

const reducers = createReducer({
  [loadOrdersSucceeded]: (state, { signage }) => {
    const { states, orders } = signage;

    const groupedOrders = groupBy(orders, 'stateId');    
    const groups = groupBy(states, 'groupName');

    let orderCount = 0;

    const orderGroups = Object.keys(groups).map(name => {
      const orders = uniqBy(groups[name]
        .reduce((a, b) => a.concat(groupedOrders[b.id]), [])
        .filter(a => !!a), 'pickupNumber');

      orderCount = orderCount + orders.length;
      
      const state = states.find(x => x.groupName == name);

      return {
        name,
        sortOrder: groups.sortOrder,
        orders,
        visibleItemCount: state?.visibleItemCount,        
        isOrderCancelled: state?.isOrderCancelled,
        displayName: state?.displayName,
        description: state?.description,
      }
    }).sort((a, b) => a.sortOrder - b.sortOrder);

    for (let i = 0; i < orderGroups.length; i++) {
      const group = orderGroups[i];
            
      if (group.visibleItemCount == 1 && group.orders && group.orders.length > 1 && i > 0) {
        const groupPrev = orderGroups[i-1];
        
        groupPrev.orders = [...group.orders.slice(1), ...groupPrev.orders];
        group.orders = [group.orders[0]];
      }
    }    

    return state.merge({ orderGroups, orderCount });
  },
  [loadLocationSucceeded]: (state, { location }) => {
    return state.merge({ location })
  }
}, INITIAL_STATE);

export default reducers;
